export default "__VITE_ASSET__8d3609f5__"